export function toForm(
  { person: { vtr_id = "" }, relation: { content_vtr_id = "", role = "", sub_role = "", person_content_relation_id = ""} }
) {
  return {
    person_vtr_id: vtr_id,
    content_vtr_id,
    role,
    sub_role,
    person_content_relation_id
  }
} 